import rq from '@/request'

const resource = 'messages'

const show = id => rq.get(`${resource}/${id}`)
const bookmark = id => rq.post(`${resource}/${id}/bookmark`)
const unBookmark = id => rq.post(`${resource}/${id}/un_bookmark`)
const favorite = id => rq.post(`${resource}/${id}/favorite`)
const unFavorite = id => rq.post(`${resource}/${id}/un_favorite`)
const deleteMessage = id => rq.delete(`${resource}/${id}`)
const editMessage = (id, data) => rq.put(`${resource}/${id}`, data)

export default {
  show,
  bookmark,
  unBookmark,
  favorite,
  unFavorite,
  deleteMessage,
  editMessage
}



// WEBPACK FOOTER //
// ./src/api/message.js